/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getIntertoysNewsLetterSubscriptionSubmitPage = (props: IncomingContent): Layout => ({
	name: 'DoubleStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'IntertoysNewsLetterSubscriptionSubmit', id: 'IntertoysNewsLetterSubscriptionSubmit' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	}
});
